function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#338af3",
  d: "M0 85.331h512v341.337H0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M255.999 159.53l7.367 22.674h23.843l-19.288 14.016 7.367 22.673-19.289-14.013-19.288 14.013 7.368-22.673-19.288-14.016h23.842zm-96.463 96.466l22.674-7.368v-23.842l14.015 19.288 22.674-7.368-14.013 19.29 14.013 19.286-22.674-7.367-14.015 19.288v-23.841zm96.465 96.463l-7.367-22.674h-23.843l19.288-14.016-7.367-22.674 19.289 14.014 19.287-14.014-7.367 22.674 19.288 14.016h-23.842zm96.463-96.466l-22.674 7.368v23.842l-14.015-19.288-22.674 7.367 14.013-19.289-14.013-19.287 22.674 7.368 14.015-19.288v23.841z",
  fill: "#f0f0f0"
});

const SvgMicronesia = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMicronesia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/micronesia.e9922ea3.svg";
export { ForwardRef as ReactComponent };